const table = {
  columnList: 'רשימת עמודות',
  noResults: 'לא נמצאו תוצאות',
  noResultsSubHeader: 'לא הצלחנו למצוא פריט התואם את החיפוש שלך',
};

export default table;
